import React, { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & {
  title?: string;
  size?: number | string;
};

function ViewAll({ size = "1em", title, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable={false}
      {...props}
    >
      <g fill="currentColor">
        <rect height="7" width="8.5" rx="1.75" ry="1.75" x="1" y="2" />
        <rect height="10" width="5.5" rx="1.75" ry="1.75" x="11.5" y="4" />
        <rect height="5.5" width="7" rx="1.75" ry="1.75" x="3" y="10.5" />
      </g>
    </svg>
  );
}

export default ViewAll;
